import React from "react";
import { Provider } from "react-redux";
import GlobalModal from "./GlobalModal";
import { store } from "shared/store";
import { AdvanceTheme } from "../advance-theme/AdvanceTheme";

export default (props) => (
  <AdvanceTheme>
    <Provider store={store}>
      <GlobalModal {...props} />
    </Provider>
  </AdvanceTheme>
);
